module.exports = __webpack_public_path__ + "img/model_43_zh.b975cffa.jpg";